import styled from "styled-components";
import { Box } from "hcss-core";

export const TextOverflow = styled(Box)`
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;
export const TextOverflowVertically = styled(Box)`
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  font-size: 1.05em;
`;
